// Vendor
import { Factory } from 'fishery';
import { faker } from '@faker-js/faker/locale/en';

// Local
import { BFSFontVariant } from 'libs/shared-types';

export const BFSFontVariantFactory = Factory.define<BFSFontVariant>(() => ({
  uuid: faker.string.uuid(),
  isItalic: faker.datatype.boolean(),
  weightIndex: faker.number.int({ min: 1, max: 9 }) * 100,
}));

export default BFSFontVariantFactory;
